import { render } from "./Gameboard_Cash_Flow.vue?vue&type=template&id=52b54382"
import script from "./Gameboard_Cash_Flow.vue?vue&type=script&lang=js"
export * from "./Gameboard_Cash_Flow.vue?vue&type=script&lang=js"

import "./Gameboard_Cash_Flow.vue?vue&type=style&index=0&id=52b54382&lang=scss"
script.render = render

export default script